import styled from "@emotion/styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
  border?: string
  isLast?: boolean
  expandedMenu?: boolean
  backgroundPanel?: string
}

export const UserContainer = styled.div<StylesProps>`
  border-radius: 7px;
  margin-bottom: ${({ isLast }) => (isLast ? "0px" : "5px")};
  border: ${({ border }) => border};
  transition: height 600ms ease-out;
  background: ${({ backgroundPanel }) => backgroundPanel ?? "red"};
  cursor: ${({ expandedMenu }) => (!expandedMenu ? "default" : "pointer")};
`

export const AccessContainer = styled.div`
  display: grid;
  grid-gap: 0.75rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  margin-bottom: 0.4rem;
  padding-inline-start: 0.4rem;
  padding-inline-end: 0.4rem;
  padding-right: 1.4rem;
  padding-left: 1.4rem;
`
export const UserCollapseButton = styled.div<StylesProps>`
  padding: 0.5rem;
  width: 100%;
  cursor: ${({ expandedMenu }) => (!expandedMenu ? "default" : "pointer")};
`

export const CollapseButtonItems = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const ItemsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const ModeratorAvatar = styled.object`
  display: inline-block;
  border-radius: 50%;
`

export const UserName = styled.p<StylesProps>`
  font-size: 0.875rem;
  margin-inline-start: 0.5rem;
  font-weight: 600;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText &&
    roomStyles?.servicePanelElementPrimaryText};
`
export const ExpandedMenu = styled.div`
display: none:
transition: max-height 0.2s ease-out;
max-height: 0px;
overflow: hidden;
cursor: default;
`

export const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  width: 100%;
  padding: 0px 0.5rem 0.5rem 0.5rem;
`
